module.exports = __webpack_public_path__ + "static/media/asset_3.e7e10d6f.jpg";